// extracted by mini-css-extract-plugin
export default {"header":"NavBar_header__ZqVLa","logo":"NavBar_logo__OGFVx","header-grid":"NavBar_header-grid__stRok","h2-container":"NavBar_h2-container__f+b0l"};